export var ExchangeStatus;
(function (ExchangeStatus) {
    ExchangeStatus["STARTED"] = "started";
    ExchangeStatus["IN_PROGRESS"] = "inProgress";
    ExchangeStatus["COMPLETE"] = "complete";
    ExchangeStatus["FAILED"] = "failed";
})(ExchangeStatus || (ExchangeStatus = {}));
export const DEFAULT_PREFILL_OPTIONS = [
    { label: 'Min', value: 10 },
    { label: 'Half', value: 50_000 },
    { label: 'All', value: 100_000 },
];
